export function BomLockedBanner({ reason }: { reason: string | null }) {
  return (
    <div
      role="status"
      className="rounded-md border border-amber-300 bg-amber-50 px-3 py-2 text-sm text-amber-900"
    >
      This BOM is locked{reason ? ` — ${reason}` : ""}. Recall the parent to edit.
    </div>
  );
}
